import AUStates from './de-DE/AU-states.json.js';
import CAStates from './de-DE/CA-states.json.js';
import CNStates from './de-DE/CN-states.json.js';
import CompanySize from './de-DE/company-size.json.js';
import CompanyType from './de-DE/company-type.json.js';
import countries from './de-DE/countries.json.js';
import DEStates from './de-DE/DE-states.json.js';
import HKStates from './de-DE/HK-states.json.js';
import INStates from './de-DE/IN-states.json.js';
import industry from './de-DE/industry.json.js';
import interests from './de-DE/interests.json.js';
import jobRole from './de-DE/job-role.json.js';
import levelOfAWSUsage from './de-DE/level-of-aws-usage.json.js';
import projectTimeline from './de-DE/project-timeline.json.js';
import PTStates from './de-DE/PT-states.json.js';
import USStates from './de-DE/US-states.json.js';
import useCase from './de-DE/use-case.json.js';
import languagePreference from './de-DE/language-preference.json.js';
import Navatar from '../de-DE/translation.json.js';

const dropdownsData = {
    ...AUStates,
    ...CAStates,
    ...CNStates,
    ...CompanySize,
    ...CompanyType,
    ...countries,
    ...DEStates,
    ...HKStates,
    ...INStates,
    ...industry,
    ...interests,
    ...jobRole,
    ...levelOfAWSUsage,
    ...projectTimeline,
    ...PTStates,
    ...USStates,
    ...useCase,
    ...Navatar.translation,
    ...languagePreference,
};

export { dropdownsData as default };
